import {updateOrgQuarterlyRoadmap} from '../../actions/user'
import store from '../../store'

export function updateQuarterlyRoadmap(roadmapId){
	return store.dispatch(updateOrgQuarterlyRoadmap(roadmapId))

}
